import { useInstance } from 'intact-vue-next';
export function useFields() {
  var instance = useInstance();
  return function getField(data, key) {
    var _instance$get = instance.get(),
      fields = _instance$get.fields;
    if (fields) {
      var field = fields[key];
      if (field) {
        return data[field];
      }
    }
    return data[key];
  };
}